import { CONFIRM_BOOKING_V2, CONFIRM_BOOKING_V2_SUCCESS, CONFIRM_BOOKING_V2_ERROR, CONFIRM_BOOKING_V2_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ConfirmBookingV2 = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_BOOKING_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CONFIRM_BOOKING_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CONFIRM_BOOKING_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CONFIRM_BOOKING_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ConfirmBookingV2;
